import React,{ useEffect, useState , useRef } from 'react';
import Jobimages from './Jobimages';
import SignatureCanvas from 'react-signature-canvas'
import { FaRegCheckCircle } from "react-icons/fa";
import { PiMinusCircle } from "react-icons/pi";
import { PiPlusCircle } from "react-icons/pi";
import 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import useLocalStorageState from 'use-local-storage-state';
import axios from 'axios';
import { useParams } from "react-router";
import { useNavigate } from 'react-router-dom';
const Jobs = () => {  
	let { id } = useParams();
	const navigate = useNavigate();
	const [token, setToken] = useLocalStorageState('token', '');
	const [data, setData] = useState([]);
	const [errcustomername,setErrcustomername]=useState('')
	const [errcustomersign,setErrcustomersign]=useState('')
	const [vehiclesdata, setVehiclesdata] = useState([]);
	const [isSignatureVisible, setIsSignatureVisible] = useState('true');
	const sigRef = useRef();
	const [signature, setSignature] = useState(null);	
	const [customername,setCustomername]=useState(null)	
	const [customernote,setCustomernote]=useState(null)	
	const [deliveryMark1,setDeliveryMark1]=useState('blockDiv')
	const [deliveryMark2,setDeliveryMark2]=useState('clearDiv')
	const [stile,setStile]=useState(['storedImages','storedImages','storedImages','storedImages','storedImages','storedImages','storedImages','storedImages','storedImages','storedImages'])
	const [imgbtn,setImgbtn]=useState([<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>])
	const [canvasWidth, setCanvasWidth] = useState(window.innerWidth * 0.8);
	const LoadJob =()=>
		{
		  let endpoint = process.env.REACT_APP_PHP_URL+'job-details';
		  const formData = {job_id:id}
			const BEARER_TOKEN = token;
			axios(endpoint, {
			  method: "POST",
			  data:formData,
			  withCredentials: true,
			  headers: {
				'Authorization': `Bearer ${BEARER_TOKEN}`,
				'Content-Type': 'application/json',
			}
			  }).then((response ) => {
					setData(response.data.data);
					setVehiclesdata(response.data.data[0].vehicles);
			  }) .catch(error => {
				navigate('/');
			  });
		}
  useEffect(() => {
	LoadJob();
  },[]);

	const openCollectionBlock=()=>{
		setDeliveryMark1('clearDiv');
		setDeliveryMark2('blockDiv');
		setIsSignatureVisible(!isSignatureVisible)
	}
	  const handleSignatureEnd = () => {
		setSignature(sigRef.current.toDataURL());
	  }
	  const clearSignature = () => {
		sigRef.current.clear();
		setSignature(null);
	  }
	const openImageBlock=(a)=>
		{
				if(stile[a]==='storedImagesDisp')
				{
					setStile(prevItems => 
						prevItems.map((item, idx) => idx === a ? 'storedImages' : stile[idx])
					  );
					  setImgbtn(prevItems => 
						prevItems.map((item, idx) => idx === a ? <PiPlusCircle /> : imgbtn[idx])
					  );					  				
				}
				else if(stile[a]==='storedImages'){
					setStile(prevItems => 
						prevItems.map((item, idx) => idx === a ? 'storedImagesDisp' : stile[idx])
					  );
					setImgbtn(prevItems => 
						prevItems.map((item, idx) => idx === a ? <PiMinusCircle /> : imgbtn[idx])
					  );	
				}
																		
	}
	const saveCollection=()=>{
		setErrcustomername('');
		setErrcustomersign('');
		if(customername==='' || customername===null)
			{
				setErrcustomername('* This field is mandetory');
			}
		else if(signature==='' || signature===null)
			{
				setErrcustomersign('* This field is mandetory');
			}
		else
			{
				let endpoint = process.env.REACT_APP_PHP_URL+'job-collection-update';
				const formData = {contact_name:customername,job_id:id,collection_notes:customernote,collection_signature:signature}
				  const BEARER_TOKEN = token;
				  axios(endpoint, {
					method: "POST",
					data:formData,
					withCredentials: true,
					headers: {
					  'Authorization': `Bearer ${BEARER_TOKEN}`,
					  'Content-Type': 'application/json',
				  }
					}).then((response ) => {
						window.location.reload();
					}) .catch(error => {
						if(error.response.data.message!==undefined)
                		{
						if(error.response.data.message.contact_name!==undefined)
							{
								setErrcustomername(error.response.data.message.contact_name[0]);
							}
						if(error.response.data.message.collection_signature!==undefined)
							{
								setErrcustomersign(error.response.data.message.collection_signature[0]);
							}
						}
						else{
							setErrcustomersign('Something went wrong!!');
							navigate('/');
						}
					});
			}
	}
	const saveDelivery=()=>{
		setErrcustomername('');
		setErrcustomersign('');		
		if(customername==='' || customername===null)
			{
				setErrcustomername('* This field is mandetory');
			}
		else if(signature==='' || signature===null)
			{
				setErrcustomersign('* This field is mandetory');
			}
		else
			{
				let endpoint = process.env.REACT_APP_PHP_URL+'job-delivery-update';
				const formData = {contact_name:customername,job_id:id,delivery_notes:customernote,delivery_signature:signature}
				  const BEARER_TOKEN = token;
				  axios(endpoint, {
					method: "POST",
					data:formData,
					withCredentials: true,
					headers: {
					  'Authorization': `Bearer ${BEARER_TOKEN}`,
					  'Content-Type': 'application/json',
				  }
					}).then((response ) => {
						window.location.reload();
					}) .catch(error => {
					if(error.response.data.message!==undefined)
                		{
						if(error.response.data.message.contact_name!==undefined)
							{
								setErrcustomername(error.response.data.message.contact_name[0]);
							}
						if(error.response.data.message.collection_signature!==undefined)
							{
								setErrcustomersign(error.response.data.message.collection_signature[0]);
							}
						}
						else{
							setErrcustomersign('Something went wrong!!');
							navigate('/');
						}
					}
					);				
			}
	}
    function strReplace(str)
	{
		return str;
	}
	function dateConvertion(date)
	{
  if (!date || date.trim() === '') {
    return ''; 
  }

  let cstdate = '';
  try {
    const myArray = date.split(" ");
    const dt = myArray[0].split("-");
    const tm = myArray[1].split(":");

    cstdate = dt[2] + '/' + dt[1] + '/' + dt[0] + ' @ ';

			if (tm[0] < 12) {
			cstdate = cstdate + tm[0] + ':' + tm[1] + 'am';
			} else {
			if (tm[0] % 12 > 9) {
				cstdate = cstdate + (tm[0] % 12) + ':' + tm[1] + 'pm';
			} else {
				cstdate = cstdate + '0' + (tm[0] % 12) + ':' + tm[1] + 'pm';
			}
			}
		} catch (error) {			
			console.error("Error formatting date:", error);
			return '';
		}

  	return cstdate;
	}
	function dtConvertion(date)
	{
	if (!date || date.trim() === '') {
		return ''; 
	}
  	let cstdate = '';
	try {
		const myArray = date.split(" ");
		const dt = myArray[0].split("-");
		cstdate = dt[2] + '/' + dt[1] + '/' + dt[0] ;
		} catch (error) {			
			console.error("Error formatting date:", error);
			return '';
		}
  	return cstdate;
	}
	return (<>
		{data.map((item,index3) => (
		<div key="jobkey" className="container">
		  <div className="row">
		  {item.status !== 'Delivered' ? (
			<div className="col-sm-12" key="jobkey1">
				<div className="card">
					  <div className="card-body">
						<h5 className="card-title">
						<b>{item.business_name}</b>
						</h5>
					<p className="card-text">#{item.po_number}</p>
					<h6 className="card-title">
						<b>Notes</b>
					</h6>
						<p className="card-text">{item.admin_notes_public}</p>
					</div>
					<br/>
				</div>
			</div>
			):(
				<div className="col-sm-12" key="jobkey1">
				<div className="card custom-card">
					  <div className="card-body">
						<h5 className="card-title">
						<FaRegCheckCircle className="checkCircle"/>
						<span className="completedtitle">{item.business_name}</span>
						</h5>
					<p className="card-text">#{item.po_number}</p>
					<h6 className="card-title">
						<b>Notes</b>
					</h6>
						<p className="card-text">{item.admin_notes_public}</p>
					</div>
					<br/>
				</div>
			</div>
			)}
			{vehiclesdata.map((item1,index1) => (
					<div className="col-sm-12" key="jobkey1">
						<div className="card">
							<div className="card-body">
								<table><tbody><tr><td style={{width:'94%'}}><p className="card-text jobsImg" style={{marginBottom: '0px',fontWeight:'600'}}>{item1.condition} {item1.type}, {item1.make} {item1.model}, {item1.registration}</p></td><td className='fafa' valign="middle"><a onClick={()=>openImageBlock(index1)}>{imgbtn[index1]}</a></td></tr></tbody></table>
								<div id="images1" className={stile[index1]}>
									<Jobimages jobid={item1.id} />										
								</div>
							</div>
						</div>
					</div>
			))}
			{item.status === 'Ready to collect' ? (
			<>
			<div className="col-sm-12" key="jobkey1">
				<div className="card">
					  <div className="card-body">
						<h5 className="card-title">
						<b>Collection <span  style={{float: 'right',right: '15px',position: 'absolute'}}>{dtConvertion(item.collection_date)}</span></b>
						</h5>
						<div className="card-text" >
							{item.collection_address.split("\n").map((line, index) => (
        					<div key={index}>{line}</div>
      						))} 
						</div>   		
						<a type="submit" className="googlebtn btn btn-primary center" href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.collection_address)}`} target="_blank">View on Google maps</a><br/>
						<div className={deliveryMark1}><a type="submit" className="loginbtn btn btn-primary center" onClick={openCollectionBlock}>Mark as Collected</a></div>
						<div className={deliveryMark2}>
						<div key="collection1"><p></p>
						<label htmlFor="note" className="form-label"><h5>Notes</h5></label>
			  			<textarea className="form-control" id="note" rows="3" onChange={(e) => setCustomernote(e.target.value)}></textarea>
			  			<br/>
			  			<label htmlFor="customerName" className="form-label"><h5>Customer Name</h5></label>
						<input type="text" className="form-control" id="customerName" aria-describedby="customerName" onChange={(e) => setCustomername(e.target.value)} />
						<div className="invalid-feedback">{errcustomername}</div>
			  			<br/>
			  			<label htmlFor="sign" className="form-label"><h5>Customer signature</h5></label>
						</div>						
						{!isSignatureVisible && (
							<SignatureCanvas 
							penColor="black"
							backgroundColor="white"
							canvasProps={{
							  width: canvasWidth,
							  height: 200,  
							  className: 'sigCanvas',
							}}

								ref={sigRef}
								onEnd={handleSignatureEnd}
								/>
							)}
							<div className={deliveryMark2}>	
							<div className="invalid-feedback">{errcustomersign}</div>
							<br/>										               
							<button className="loginbtn btn btn-primary center" onClick={clearSignature}>Clear</button>
							<br/>
			  				<a type="submit" className="loginbtn btn btn-primary center" onClick={saveCollection}>Mark as Collected</a>
							</div>						
						</div>			
					</div>
					<br/>
				</div>
			</div>
		<div className="col-sm-12" >
			<div className="card">
				  <div className="card-body">
					<h5 className="card-title">
					<b>Delivery <span  style={{float: 'right',right: '15px',position: 'absolute'}}>{dtConvertion(item.delivery_date)}</span></b>
					</h5>
					<div className="card-text">
						{item.delivery_address.split("\n").map((line, index) => (
						<div key={index}>{line}</div>
						))} 
					</div>
					<a type="submit" className="googlebtn btn btn-primary center" href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.delivery_address)}`} target="_blank">View on Google maps</a>
				</div>
				<br/>
			</div>
		</div>
		</>	
			):item.status === 'Ready to deliver' ? (			
				<>
				<div className="col-sm-12" >
					<div className="card">
						  <div className="card-body">
							<h5 className="card-title">
							<b>Delivery <span  style={{float: 'right',right: '15px',position: 'absolute'}}>{dtConvertion(item.delivery_date)}</span></b>
							</h5>
							<div className="card-text" >
							{item.delivery_address.split("\n").map((line, index) => (
								<div key={index}>{line}</div>
							))} 	
							</div>   		
							<a type="submit" className="googlebtn btn btn-primary center"  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.delivery_address)}`} target="_blank">View on Google maps</a><br/>
							<div className={deliveryMark1}><a type="submit" className="loginbtn btn btn-primary center" onClick={openCollectionBlock}>Mark as Delivered</a></div>
							<div className={deliveryMark2}>
							<div key="collection1"><p></p>
							<label htmlFor="note" className="form-label"><h5>Notes</h5></label>
							  <textarea className="form-control" id="note" rows="3" onChange={(e) => setCustomernote(e.target.value)}></textarea>
							  <br/>
							  <label htmlFor="customerName" className="form-label"><h5>Customer Name</h5></label>
							  <input type="text" className="form-control" id="customerName" aria-describedby="customerName" onChange={(e) => setCustomername(e.target.value)} />
							  <div className="invalid-feedback">{errcustomername}</div>
							  <br/>
							  <label htmlFor="sign" className="form-label"><h5>Customer signature</h5></label>
							</div>							
							  {!isSignatureVisible && (
							<SignatureCanvas 
							penColor="black"
							backgroundColor="white"
							canvasProps={{
							  width: canvasWidth,
							  height: 200,  
							  className: 'sigCanvas',
							}}

								ref={sigRef}
								onEnd={handleSignatureEnd}
								/>
							)}					
	
								<div className={deliveryMark2}>		
								  <div className="invalid-feedback">{errcustomersign}</div>
								  <br/>												               
								  <button className="loginbtn btn btn-primary center" onClick={clearSignature}>Clear</button>
								  <br/>
								  <a type="submit" className="loginbtn btn btn-primary center" onClick={saveDelivery}>Mark as Delivered</a>
								</div>						
							</div>			
						</div>
						<br/>
					</div>
				</div>
				<div className="col-sm-12">
					<div className="card  custom-card">
						<div className="card-body">
							<h5 className="card-title">
							<FaRegCheckCircle className="checkCircle"/>
							<span className="completedtitle">Collection Completed</span>
							</h5>
							<div className="card-text"> {item.collection_address.split("\n").map((line, index) => (
        							<div key={index}>{line}</div>
      							))}</div>
								<center><a href="#" className="completedblock btn btn-primary"><FaRegCheckCircle className="checkCircle"/><span className="completeddate">Collected - {dateConvertion(item.collection_date)}</span></a></center>
						</div>
					</div>
				</div>
			</>	

			):(
			<><div className="col-sm-12">
			<div className="card  custom-card">
				  <div className="card-body">
					<h5 className="card-title">
					<FaRegCheckCircle className="checkCircle"/>
					 <span className="completedtitle">Delivery Completed</span>
					</h5>
					<div className="card-text">
					{item.delivery_address.split("\n").map((line, index) => (
						<div key={index}>{line}</div>
						))} 
					</div>
						<center><a href="#" className="completedblock btn btn-primary"><FaRegCheckCircle className="checkCircle"/><span className="completeddate">Delivered - {dateConvertion(item.delivery_date)}</span></a></center>
				  </div>
			</div>
		</div>
		<div className="col-sm-12">
			<div className="card  custom-card">
				  <div className="card-body">
					<h5 className="card-title">
					<FaRegCheckCircle className="checkCircle"/>
					<span className="completedtitle">Collection Completed</span>
					</h5>
					<div className="card-text">
						{item.collection_address.split("\n").map((line, index) => (
        				<div key={index}>{line}</div>
      					))}
					</div>
					<center><a href="#" className="completedblock btn btn-primary"><FaRegCheckCircle className="checkCircle"/><span className="completeddate">Collected - {dateConvertion(item.collection_date)}</span></a></center>
				  </div>
			</div>
		</div> </>
			)} 	
			<div className="col-sm-12"></div>
		  </div>
		</div>	
		))}
	</>);

}
export default Jobs;
